import React, { useState, useEffect, useMemo } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { useNavigate } from "react-router-dom";
import { NavLink, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TransportMenu from "./TransportMenu";
import moment from "moment";
import Pagination from "../General/Pagination";
import { scrollToTop } from "../Shared/ScrollOnTop";
import { Form, PageItem } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import MonthsDropDown from "../Shared/MonthsDropDown";
import YearsDropDown from "../Shared/YearsDropDown";

function ManageBankAccounts(props) {
  const navigate = useNavigate();
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [isUpdated, setIsUpdated] = useState(false);
  const [RouteCode, SetRouteCode] = useState("");
  const [AreaName, SetAreaName] = useState("");
  const [BusNo, SetBusNo] = useState("");

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showFilters, setShowFilters] = useState(true);
  const [validated, setValidated] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [pendingBusNumber, setPendingBusNumber] = useState("");
  const [printFeeMonth, setPrintFeeMonth] = useState(moment().format("M"));
  const [printFeeYear, setPrintFeeYear] = useState(moment().format("YYYY"));

  const openBusStudentListPrint = (busNumber) => {
    setPendingBusNumber((busNumber || "").trim());
    setPrintFeeMonth(moment().format("M"));
    setPrintFeeYear(moment().format("YYYY"));
    setShowPrintModal(true);
  };

  const closePrintModal = () => {
    setShowPrintModal(false);
    setPendingBusNumber("");
  };

  const navigateToBusStudentList = (withFeeMonth) => {
    if (!pendingBusNumber) {
      return;
    }
    const base = `/Transport/PrintBuswise-StudentList/?BusNumber=${encodeURIComponent(pendingBusNumber)}`;
    const url = withFeeMonth
      ? `${base}&FeeMonth=${parseInt(printFeeMonth, 10) || 0}&FeeYear=${parseInt(printFeeYear, 10) || 0}`
      : base;
    closePrintModal();
    navigate(url);
  };

  const busWiseCounts = useMemo(() => {
    const counts = {};
    (listOfLedger || []).forEach((item) => {
      const busNo = (item.BusNumber || "").trim();
      if (!busNo) {
        return;
      }
      const studentCount = Number(item.NoofStudents || 0);
      counts[busNo] = (counts[busNo] || 0) + (Number.isNaN(studentCount) ? 0 : studentCount);
    });

    return Object.keys(counts)
      .sort()
      .map((busNo) => ({
        busNo,
        studentCount: counts[busNo],
      }));
  }, [listOfLedger]);

  const totalBusStudents = useMemo(() => {
    return busWiseCounts.reduce((sum, item) => sum + (Number(item.studentCount) || 0), 0);
  }, [busWiseCounts]);

  useEffect(() => {
    document.title = "Manage Bus Routes";

    setIsUpdated(false);
    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: pageNo,
      pageSize: pageSize,
      Root_Code: RouteCode,
      Area_Name: AreaName,
      BusNumber: BusNo,
      SchoolID: 1,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Busroute/GetBusRoutes",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        //console.log(response.data);
        setLedger(response.data.ListofRecords || []);
        setLoading(false);
        setTotalRecords(response.data.totalRecords || []);
      })
      .catch(function (error) {
        //console.log(error);
      });
  }, [pageNo, pageSize, isUpdated, BusNo, RouteCode, AreaName]);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      const data = {
        AccessKey: AccessKey,
        UserID: UserID,
        MemberType: MemberType,
        pageNo: pageNo,
        pageSize: pageSize,
      };

      var api_config = {
        method: "post",
        url: config.base_url + "Busroute/GetBusRoutes",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(api_config)
        .then(function (response) {
          //console.log(response.data);
          setLedger(response.data.ListofRecords);
          setLoading(false);
          setTotalRecords(response.data.totalRecords);
        })
        .catch(function (error) {
          //console.log(error);
        });
    }

    setValidated(true);
  };

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const renderLedger = () => {
    if (
      listOfLedger &&
      listOfLedger.length != null &&
      listOfLedger.length > 0
    ) {
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{item.Root_ID}</td>
            <td>{item.Root_Code}</td>
            <td>{item.Area_Name}</td>
            <td>{item.BusNumber}</td>
            <td>{item.Root_Details}</td>
            <td>{item.PickDrop_Fee}</td>
            <td>{item.NoofStudents}</td>
            <td>
              <ul
                className="inline-action"
                aria-labelledby="dropdownMenuButton1"
              >
                <li>
                  <NavLink
                    to={"/Transport/EditBusRoutes/" + item.Root_ID}
                    className=" green"
                  >
                    <i className="ri-edit-line"></i>
                  </NavLink>
                </li>
                <li>
                  <button
                    onClick={(e) => deleteBusRoute(item.Root_ID)}
                    className="red"
                  >
                    <i className="ri-delete-bin-line"></i>
                  </button>
                </li>
                <li>
                  <NavLink
                    to={`/Transport/PrintRoutewise-AttendenceSheet/?routeid=${item.Root_ID}&&routename=${item.Area_Name}`}
                    className=" green"
                  >
                    <i className="ri-map-pin-line"></i>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={`/Transport/PrintBuswise-AttendenceSheet/?BusNumber=${item.BusNumber}`}
                    className=" blue"
                  >
                    <i className="ri-bus-line"></i>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={`/Transport/PrintRoutewise-StudentList/?routeid=${item.Root_ID}&&routename=${item.Area_Name}`}
                    className="green"
                  >
                    <i className="ri-pages-line"></i>
                  </NavLink>
                </li>
                <li>
                  <button
                    type="button"
                    className="blue"
                    title="Print bus-wise student list"
                    onClick={() => openBusStudentListPrint(item.BusNumber)}
                  >
                    <i className="ri-pages-line"></i>
                  </button>
                </li>
              </ul>
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="8">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };
  const deleteBusRoute = (ID) => {
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      Root_ID: ID,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "/Busroute/DeleteBusRoute",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        //console.log(response.data);
        if (response.data.status_code == 1) {
          setIsUpdated(true);
        }
        // setIsUpdated(false);
      })
      .catch(function (error) {
        //console.log(error);
      });
  };

  return (
    <>
      <TransportMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    {" "}
                    <Link to="/Transport/TransportDashboard">Transport</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Manage Bus Routes
                  </li>
                </ol>
              </nav>
              <div className="page-title">Manage Bus Routes</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link
                  to="/Transport/AddBusRoutes"
                  className="button button-white button-icon"
                >
                  Add Bus Route
                  <i className="ri-add-line"></i>
                </Link>

                <button
                  onClick={() => {
                    setShowFilters((prevIsActive) => !prevIsActive);
                  }}
                  className="button button-white button-icon"
                >
                  {showFilters ? "Hide Filters" : "Show Filters"}
                  <i className="ri-filter-3-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`collapse ${showFilters ? "show" : ""} `}
        id="collapseFilteres"
      >
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <div className="page-content">
            <div className="container">
              <div className="card mb-2">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label>Area Name:</label>
                        <input
                          type="text"
                          name="txtAreaName"
                          onChange={(e) => SetAreaName(e.target.value)}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label className="">Route Code:</label>
                        <input
                          type="text"
                          name="txtRouteCode"
                          onChange={(e) => SetRouteCode(e.target.value)}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label className="">Bus No:</label>
                        <input
                          type="text"
                          name="txtBusNo"
                          onChange={(e) => SetBusNo(e.target.value)}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-2 offset-md-1">
                      <div className="form-group">
                        <button
                          type="submit"
                          value="Search"
                          onClick={handleSubmit}
                          className="button button-primary mt-4 w-100"
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body">
              <table className="table table-theme table-hover">
                <thead>
                  <tr>
                    <th>Sr#</th>
                    <th>Route Code</th>
                    <th>Area Name</th>
                    <th>Bus Number</th>
                    <th>Route Details</th>
                    <th>Transport Fee</th>
                    <th>No Of Students</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td className="text-center" colSpan="8">
                        <Spinner animation="border" role="status"></Spinner>
                      </td>
                    </tr>
                  ) : (
                    <>{renderLedger()}</>
                  )}
                </tbody>
              </table>
              {totalRecords > 10 && (
                <div className="pagination-wrap">
                  <div className="row align-items-center">
                    <div className="col-md-2 form_default">
                      <div className="d-flex align-items-center">
                        <label className="me-2" style={{ fontSize: "15px" }}>
                          Page Size
                        </label>
                        <div className="form-group">
                          <select
                            className="form-select"
                            style={{ width: "100px" }}
                            onChange={(e) => {
                              setPageNo(1);
                              setPageSize(parseInt(e.target.value));
                            }}
                          >
                            <option value="10" selected>
                              10
                            </option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <Pagination
                      pageNo={pageNo}
                      pageSize={pageSize}
                      totalRecords={totalRecords}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="card mt-md-3">
            <div className="card-body">
              <div className="row justify-content-end">
                <div className="col-md-2">
                  <NavLink
                    target="_blank"
                    to={`/Transport/print/BusRoutes?routename=${AreaName}&routecode=${RouteCode}&busno=${BusNo} `}
                    className="button button-primary w-100"
                  >
                    Print This Report
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
          <div className="card mt-md-3">
            <div className="card-body">
              <div className="card-title mb-3">Bus Wise Students Count</div>
              <div className="table-responsive">
                <table className="table table-theme table-hover">
                  <thead>
                    <tr>
                      <th>Bus Number</th>
                      <th className="text-end">Students</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td className="text-center" colSpan="2">
                          <Spinner animation="border" role="status"></Spinner>
                        </td>
                      </tr>
                    ) : busWiseCounts.length > 0 ? (
                      <>
                        {busWiseCounts.map((item) => (
                          <tr key={`bus-wise-${item.busNo}`}>
                            <td>{item.busNo}</td>
                            <td className="text-end">{item.studentCount}</td>
                          </tr>
                        ))}
                        <tr>
                          <td className="text-end"><strong>Total</strong></td>
                          <td className="text-end"><strong>{totalBusStudents}</strong></td>
                        </tr>
                      </>
                    ) : (
                      <tr>
                        <td colSpan="2" className="text-center">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal className="theme-modal" show={showPrintModal} onHide={closePrintModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Print Bus Student List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-3">
            Bus: <strong>{pendingBusNumber}</strong>
          </p>
          <p className="text-muted small mb-3">
            Optionally select a fee month to show transport fee (005) paid status on the report.
            Unpaid students are left blank.
          </p>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Fee Month</label>
              <select
                className="form-select"
                value={printFeeMonth}
                onChange={(e) => setPrintFeeMonth(e.target.value)}
              >
                <option value="">? None ?</option>
                <MonthsDropDown />
              </select>
            </div>
            <div className="col-md-6">
              <label className="form-label">Fee Year</label>
              <select
                className="form-select"
                value={printFeeYear}
                onChange={(e) => setPrintFeeYear(e.target.value)}
              >
                <option value="">? None ?</option>
                <YearsDropDown currentYearSelectd={printFeeYear} />
              </select>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="button button-white" onClick={closePrintModal}>
            Cancel
          </button>
          <button
            type="button"
            className="button button-secondary"
            onClick={() => navigateToBusStudentList(false)}
          >
            Print without fee month
          </button>
          <button
            type="button"
            className="button button-primary"
            onClick={() => {
              if (!printFeeMonth || !printFeeYear) {
                toast.error("Select fee month and year, or use Print without fee month.", {
                  position: toast.POSITION.TOP_RIGHT,
                });
                return;
              }
              navigateToBusStudentList(true);
            }}
          >
            Print with fee status
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ManageBankAccounts;
